import { Component, OnInit } from '@angular/core';
import { SessionServiceService } from '../services/session-service.service';
import { AdministrationService } from './administration.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-admin-area',
  templateUrl: './admin-area.component.html',
  styleUrls: ['./admin-area.component.scss']
})
export class AdminAreaComponent implements OnInit {
  constructor(
    private _session: SessionServiceService,
    public adminService: AdministrationService,
  ) { }

  ngOnInit() {
    this.adminService.updateAuthentication();
  }

  getAuthURL(){
    return environment.API_URL + '/auth/gitlab';
  }

  public getToolbarTitle(): string {
    return this._session.getToolName() + ' ' + this._session.getCurrentToolVersion();
  }

}
